/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as cx from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IApi } from "../api/api";
import { BrandName } from "../brand/brandName";
import { PAYMENT_PATH, PROFILE_PATH, SIGN_IN_PATH } from "../paths/pathIndex";
import { IAppState } from "./appState";

import "./appNav.scss";

interface IOwnProps {
    api: IApi;
}

interface IStateProps {
    userInfo: UserInfo | false | undefined;
}

type IProps = IOwnProps & IStateProps;

interface IState {
    isOpen: boolean;
}

class UnconnectedAppNav extends React.PureComponent<IProps, IState> {
    public state: IState = {
        isOpen: false,
    };

    public render() {
        const { children } = this.props;
        const { isOpen } = this.state;
        return (
            <>
                <a className="scpr-AppNav-hamburger" onClick={this.openAppNav}>
                    <i className="material-icons">menu</i>
                </a>

                <span className={cx("scpr-AppNav", { "scpr-AppNav-open": isOpen })}>
                    <ul className="side-nav">
                        <li>
                            <div className="user-view">
                                {this.renderHeader()}
                            </div>
                        </li>

                        {this.renderMain()}

                        <li><div className="divider" /></li>

                        {this.renderSiteLinks()}
                    </ul>

                    <div id="sidenav-overlay" onClick={this.closeAppNav} />
                </span>

                <div className="scpr-AppNav-sidecar">
                    {children}
                </div>
            </>
        );
    }

    private renderHeader() {
        const { userInfo } = this.props;

        if (userInfo == null) {
            return (
                <>
                    <div className="scpr-AppNav-gray-background background" />

                    // TODO: LOADING
                </>
            );
        }

        if (userInfo === false) {
            return (
                <>
                    <div className="scpr-AppNav-gray-background background" />

                    <BrandName />
                </>
            );
        }

        return (
            <>
                <div className="scpr-AppNav-user-background background" />

                {this.renderUser(userInfo)}
            </>
        );
    }

    private renderUser = (userInfo: UserInfo) => {
        const { displayName, email, photoURL } = userInfo;
        return (
            <>
                <Link onClick={this.closeAppNav} to={PROFILE_PATH}>
                    <img className="circle" src={photoURL || undefined} />
                </Link>
                <span className="white-text name">{displayName}</span>
                <span className="white-text email">{email}</span>
            </>
        );
    };

    private renderMain() {
        const { api, userInfo } = this.props;
        const { userService } = api;

        if (userInfo == null) {
            return null;
        }

        if (userInfo === false) {
            return (
                <li>
                    <Link className="btn" onClick={this.closeAppNav} to={SIGN_IN_PATH}>
                        Sign in to Account
                    </Link>
                </li>
            );
        }

        return (
            <>
                <li>
                    <Link onClick={this.closeAppNav} to={PAYMENT_PATH}>
                        Payment Methods
                    </Link>
                </li>
                <li>
                    <a onClick={userService.signOut}>Sign-out</a>
                </li>
            </>
        );
    }

    private renderSiteLinks() {
        return (
            <li>
                <Link onClick={this.closeAppNav} to="/">getScaper.com</Link>
            </li>
        )
    }

    private closeAppNav = () => {
        this.setState({ isOpen: false });
    };

    private openAppNav = () => {
        this.setState({ isOpen: true });
    };
}

function mapStateToProps(state: IAppState): IStateProps {
    const { user } = state;
    const { userInfo } = user;
    return { userInfo };
}

export const AppNav = connect<IStateProps, {}, IOwnProps, IAppState>(mapStateToProps)(UnconnectedAppNav);
